<div class="container" [class.container--open]="isSettingsVisible" [class.settings-changed]="isSettingsChanged">
    <!-- Search box -->
    <div class="input-container">
        <div class="focus-overlay"></div>
        <mat-form-field appearance="fill">
            <mat-icon matPrefix svgIcon="search" class="input-prefix"></mat-icon>
            <input
                [(ngModel)]="formData.query"
                (keyup.Enter)="onSubmit()"
                type="text"
                matInput
                class="search-term"
                placeholder="Search Accounts by Name, Address, UUID, etc."
            />
            <mat-icon matSuffix tabindex="0" class="input-suffix right-arrow" (click)="onSubmit()"
                ><img src="assets/images/circle_move_forward.png" alt="edit icon"
            /></mat-icon>
        </mat-form-field>
    </div>

    <!-- Collapsible settings pane -->
    <div class="settings-container">
        <div class="settings">
            <div class="filters-container">
                <div class="filters__title">Search by</div>
                <div class="filters">
                    <ng-container *ngFor="let f of filters; trackBy: trackFilterBy">
                        <mat-checkbox [(ngModel)]="formData.filters[f.key]">{{ f.display }}</mat-checkbox>
                    </ng-container>
                </div>
            </div>
            <div class="actions">
                <button (click)="onClear()" class="actions__clear" mat-stroked-button>
                    <span>Clear</span>
                </button>
                <button (click)="onSubmit()" class="actions__apply" mat-flat-button>
                    <span>Apply</span>
                </button>
            </div>
        </div>
    </div>
</div>
